import React, { useRef } from 'react';
import { DragDropContext } from '@hello-pangea/dnd';
import KanbanColumn from './KanbanColumn';
import styles from './afterpay.module.scss';

const KanbanBoard = ({ columns, onDragEnd, enableDrag = true, isFullscreen = false, onCardClick, onManageTags, onCancelShipment, onReport }) => {
  const scrollContainerRef = useRef(null);

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div
        ref={scrollContainerRef}
        className={styles.kanbanBoardInner}
        style={{
          scrollbarWidth: 'thin',
          scrollbarColor: document.documentElement.getAttribute('data-theme') === 'dark' ? '#6B7280 transparent' : 'var(--scrollbar-thumb) transparent'
        }}
      >
        {columns.map((column, index) => (
          <div
            key={String(column.id)}
            style={{
              minWidth: '300px',
              width: '300px',
              flexShrink: 0,
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <KanbanColumn
              column={column}
              isFirstColumn={index === 0}
              index={index}
              enableDrag={enableDrag}
              isFullscreen={isFullscreen}
              onCardClick={onCardClick}
              onManageTags={onManageTags}
              onCancelShipment={onCancelShipment}
              onReport={onReport}
            />
          </div>
        ))}
      </div>
    </DragDropContext>
  );
};

export default KanbanBoard;
